// extracted by mini-css-extract-plugin
module.exports = {"page":"fourOhFour_page__6iM2w","content":"fourOhFour_content__1tjGM"};